import { FormGroupHeader } from "@/components/shared";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TariffComponent, HolidayComponent, VacationDaysComponent, SocialSecurityComponent, LiabilityInsuranceComponent, VacationBonusComponent, ChristmasBonusComponent } from "./Components";

enum ConfigurationTab {
  // eslint-disable-next-line no-unused-vars
  TARIFF = "tariff",
  // eslint-disable-next-line no-unused-vars
  SOCIAL_SECURITY = "social-security",
  // eslint-disable-next-line no-unused-vars
  LIABILITY_INSURANCE = "liability-insurance",
  // eslint-disable-next-line no-unused-vars
  VACATION_BONUS = "vacation-bonus",
  // eslint-disable-next-line no-unused-vars
  CHRISTMAS_BONUS = "christmas-bonus",
  // eslint-disable-next-line no-unused-vars
  VACATION_DAYS = "vacation-days",
  // eslint-disable-next-line no-unused-vars
  HOLIDAY = "holiday"
}

function ConfigurationsComponent() {
  const { t } = useTranslation(["translation", "components", "tables", "common"]);
  const [activeTab, setActiveTab] = useState<ConfigurationTab>(ConfigurationTab.TARIFF);

  const handleTabChange = (value: string) => {
    setActiveTab(value as ConfigurationTab);
  };

  return (
    <div>
      <FormGroupHeader
        className="pr-4 pl-2"
        title={t("settings.configurations.title")}
        description={t("settings.configurations.description")}
      />
      <div className="pr-4 pl-2">
        <Tabs value={activeTab} onValueChange={handleTabChange}>
          <TabsList className="justify-start w-full overflow-x-auto overflow-y-hidden">
            <TabsTrigger value={ConfigurationTab.TARIFF}>{t("settings.configurations.tabs.tariff")}</TabsTrigger>
            <TabsTrigger value={ConfigurationTab.SOCIAL_SECURITY}>{t("settings.configurations.tabs.socialsecurity")}</TabsTrigger>
            <TabsTrigger value={ConfigurationTab.LIABILITY_INSURANCE}>{t("settings.configurations.tabs.liabilityinsurance")}</TabsTrigger>
            <TabsTrigger value={ConfigurationTab.VACATION_BONUS}>{t("settings.configurations.tabs.vacationbonus")}</TabsTrigger>
            <TabsTrigger value={ConfigurationTab.CHRISTMAS_BONUS}>{t("settings.configurations.tabs.christmasbonus")}</TabsTrigger>
            <TabsTrigger value={ConfigurationTab.VACATION_DAYS}>{t("settings.configurations.tabs.vacationdays")}</TabsTrigger>
            <TabsTrigger value={ConfigurationTab.HOLIDAY}>{t("settings.configurations.tabs.holiday")}</TabsTrigger>
          </TabsList>
          {activeTab === ConfigurationTab.TARIFF && (
            <TabsContent value={ConfigurationTab.TARIFF}>
              <TariffComponent />
            </TabsContent>
          )}
          {activeTab === ConfigurationTab.SOCIAL_SECURITY && (
            <TabsContent value={ConfigurationTab.SOCIAL_SECURITY}>
              <SocialSecurityComponent />
            </TabsContent>
          )}
          {activeTab === ConfigurationTab.LIABILITY_INSURANCE && (
            <TabsContent value={ConfigurationTab.LIABILITY_INSURANCE}>
              <LiabilityInsuranceComponent />
            </TabsContent>
          )}
          {activeTab === ConfigurationTab.VACATION_BONUS && (
            <TabsContent value={ConfigurationTab.VACATION_BONUS}>
              <VacationBonusComponent />
            </TabsContent>
          )}
          {activeTab === ConfigurationTab.CHRISTMAS_BONUS && (
            <TabsContent value={ConfigurationTab.CHRISTMAS_BONUS}>
              <ChristmasBonusComponent />
            </TabsContent>
          )}
          {activeTab === ConfigurationTab.VACATION_DAYS && (
            <TabsContent value={ConfigurationTab.VACATION_DAYS}>
              <VacationDaysComponent />
            </TabsContent>
          )}
          {activeTab === ConfigurationTab.HOLIDAY && (
            <TabsContent value={ConfigurationTab.HOLIDAY}>
              <HolidayComponent />
            </TabsContent>
          )}
        </Tabs>
      </div>
    </div>
  );
}

export default ConfigurationsComponent;
